import React, { useState, useEffect } from "react";
import "./../styles/paginationBridge.css";
import { Button } from "react-md";
import FontIcon from "react-md/lib/FontIcons";

// Use as below
// <PaginationBridge
//   initialPageNum={0}
//   initialTotalCount={23}
//   initialPageSize={PAGE_SIZE}
//   onPageChange={(page, start, end) => {
//     console.log(
//       `Currently showing page ${
//         page + 1
//       }: items ${start} to ${end}`
//     );
//   }}
// />

const PaginationBridge = ({
  initialPageNum = 0,
  initialTotalCount = 0,
  initialPageSize = 0,
  onPageChange = () => {},
}) => {
  const [pageNum, setPageNum] = useState(initialPageNum);
  const [totalCount, setTotalCount] = useState(initialTotalCount);
  const [pageSize, setPageSize] = useState(initialPageSize);

  // Call parent's callback whenever pageNum, totalCount, or pageSize changes
  useEffect(() => {
    const start = totalCount === 0 ? 0 : pageNum * pageSize + 1;
    const end =
      totalCount < (pageNum + 1) * pageSize
        ? totalCount
        : (pageNum + 1) * pageSize;

    onPageChange(pageNum, start, end);
  }, [pageNum, totalCount, pageSize, onPageChange]);

  return (
    <div className="bridge-pagination-container">
      <Button
        className="page-button-left"
        onClick={() => setPageNum((pageNum) => pageNum - 1)}
        disabled={pageNum === 0}
      >
        <FontIcon className={pageNum === 0 ? "icon-disable" : "icon-enable"}>
          arrow_drop_up
        </FontIcon>
      </Button>

      <div>{`Showing`}&nbsp;</div>

      {totalCount === 0 ? (
        <div style={{ color: "#ef7c01" }}>0</div>
      ) : (
        <div style={{ color: "#ef7c01" }}>
          {`${pageNum * pageSize + 1} - ${
            totalCount < (pageNum + 1) * pageSize
              ? totalCount
              : (pageNum + 1) * pageSize
          }`}
        </div>
      )}

      <div>&nbsp;{`of ${totalCount}`}</div>

      <Button
        className="page-button-right"
        onClick={() => setPageNum((pageNum) => pageNum + 1)}
        disabled={totalCount <= (pageNum + 1) * pageSize}
      >
        <FontIcon
          className={
            totalCount <= (pageNum + 1) * pageSize
              ? "icon-disable"
              : "icon-enable"
          }
        >
          arrow_drop_up
        </FontIcon>
      </Button>
    </div>
  );
};

export default PaginationBridge;
